import { ApiService } from '../../api/api-service';
import { State } from '../../types';

const SERVICE_ROOT = '/geographic';

/**
 * API response format for State from backend
 */
interface StateResponseDto {
  id: number;
  stateName: string;
  stateAbbreviation: string;
}

/**
 * Service for geographic-related API operations
 */
export class GeographicService extends ApiService {
  /**
   * Get all states
   * @returns Promise resolving to all states
   */
  async getAllStates(): Promise<State[]> {
    const response = await this.handleApiCall<StateResponseDto[]>(
      () => this.client.get(`${SERVICE_ROOT}/states`),
      'Error fetching all states'
    );

    // Transform API response to frontend format
    return response.map(state => ({
      code: state.stateAbbreviation,
      name: state.stateName,
    }));
  }
}
